
import { MealIngredient } from 'fitbeat.models';
import { IMealIngredientsRepository } from '../interfaces';

// cached for the duration of the repository lifetime
export class CachedMealIngredientsRepository implements IMealIngredientsRepository {
    private Cached: MealIngredient[];
    constructor(private underlyingRepository: IMealIngredientsRepository) { }
    public async getAll(): Promise<MealIngredient[]> {
        if (!this.Cached) {
            this.Cached = await this.underlyingRepository.getAll();
        }
        return this.Cached;
    }

    public add(ingredient: MealIngredient): Promise<MealIngredient> {
        throw new Error('Method not implemented.');
    }
    public get(uid: string): Promise<MealIngredient> {
        throw new Error('Method not implemented.');
    }
    public update(ingredient: MealIngredient): Promise<MealIngredient> {
        throw new Error('Method not implemented.');
    }

}
